// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3384":"56e78920c8eb3849","8393":"21dcc18ae2bef1dc","8852":"da2cee088a2aaa73"}[chunkId] + ".js";
};